import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import selectors from '../selectors';
import entryActions from '../entry-actions';
import ActionTypes from '../constants/ActionTypes';
import { BoardMembershipRoles } from '../constants/Enums';
import BoardActions from '../components/BoardActions';

const mapStateToProps = (state) => {
  const allUsers = selectors.selectUsers(state);
  const isCurrentUserManager = selectors.selectIsCurrentUserManagerForCurrentProject(state);
  const memberships = selectors.selectMembershipsForCurrentBoard(state);
  const labels = selectors.selectLabelsForCurrentBoard(state);
  const filterUsers = selectors.selectFilterUsersForCurrentBoard(state);
  const filterLabels = selectors.selectFilterLabelsForCurrentBoard(state);
  const filterText = selectors.selectFilterTextForCurrentBoard(state);
  // FAMILY-EXT: feature 1
  const showHiddenCards = selectors.selectShowHiddenForCurrentBoard(state);
  // FAMILY-EXT: фильтр "Только активные"
  const showOnlyActive = selectors.selectShowOnlyActiveForCurrentBoard(state);
  const boardId = selectors.selectPath(state).boardId;
  const currentUserMembership = selectors.selectCurrentUserMembershipForCurrentBoard(state);

  const isCurrentUserEditor =
    !!currentUserMembership && currentUserMembership.role === BoardMembershipRoles.EDITOR;

  return {
    memberships,
    labels,
    filterUsers,
    filterLabels,
    filterText,
    allUsers,
    canEdit: isCurrentUserEditor,
    canEditMemberships: isCurrentUserManager,
    // FAMILY-EXT: feature 1
    showHiddenCards,
    // FAMILY-EXT: фильтр "Только активные"
    showOnlyActive,
    boardId,
  };
};

const mapDispatchToProps = (dispatch) => ({
  ...bindActionCreators(
    {
      onMembershipCreate: entryActions.createMembershipInCurrentBoard,
      onMembershipUpdate: entryActions.updateBoardMembership,
      onMembershipDelete: entryActions.deleteBoardMembership,
      onUserToFilterAdd: entryActions.addUserToFilterInCurrentBoard,
      onUserFromFilterRemove: entryActions.removeUserFromFilterInCurrentBoard,
      onLabelToFilterAdd: entryActions.addLabelToFilterInCurrentBoard,
      onLabelFromFilterRemove: entryActions.removeLabelFromFilterInCurrentBoard,
      onLabelCreate: entryActions.createLabelInCurrentBoard,
      onLabelUpdate: entryActions.updateLabel,
      onLabelMove: entryActions.moveLabel,
      onLabelDelete: entryActions.deleteLabel,
      onTextFilterUpdate: entryActions.filterText,
    },
    dispatch,
  ),
  // FAMILY-EXT: feature 1 — клиентский тоггл, без сервера/саги
  onShowHiddenToggle: (boardId) =>
    dispatch({
      type: ActionTypes.BOARD_TOGGLE_SHOW_HIDDEN,
      payload: { boardId },
    }),
  // FAMILY-EXT: фильтр "Только активные" — клиентский бинарный toggle
  onShowOnlyActiveToggle: (boardId) =>
    dispatch({
      type: ActionTypes.BOARD_TOGGLE_SHOW_ONLY_ACTIVE,
      payload: { boardId },
    }),
});

export default connect(mapStateToProps, mapDispatchToProps)(BoardActions);
